import useDeletePost from "./Hooks/useDeletePosts";
import Confirm from "../Tools/Confirm";
import { txt } from "../../services/translation";

export default function Remove({open, id, pageNumber, onClose, queryKey}){

    const deletePost = useDeletePost(queryKey);

    const handleConfirm = () => {
        deletePost.mutate({id: id, page: pageNumber});
        return onClose();
    }

    return <Confirm 
        open={open} 
        onClose={onClose} 
        onConfirm={handleConfirm}
    >
        {txt('confirmDeletePostMessage')}
    </Confirm>
}